export enum EstateType {
  LEGACY = "Legacy",
  RESIDENTIAL_COMMUNITY = "Residential Community",
  LAND_SUBDIVISION = "Land Subdivision",
}
